import * as React from "react";

const ArrowVerifyIconSVG = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
    <path
      fill="#5B21B6"
      d="m9.533 18-1.065-1.065L13.401 12 8.468 7.065 9.532 6l6 6z"
    ></path>
  </svg>
);

export default ArrowVerifyIconSVG;
